<template>
  <div class="dropdown"
    :class="{
      center: position === 'center',
      start: position === 'start',
      end: position === 'end',
      small: size === 'small',
    }"
  >

    <slot></slot>
  </div>
</template>
<script>
  import Textfield from "@/components/atoms/Textfield.vue";

  export default {
    name: "Dropdown",
    components: {
      Textfield
    },
    props: {
      size: String,
      position: String
    }
  }
</script>
<style lang="scss">
  .dropdown {
    position: absolute;
    top: 43px;
    min-width: 137px;
    width: max-content;
    max-width: 220px;
    height: 278px;
    padding: 8px;
    border-radius: 10px;
    backdrop-filter: blur(6px);
    border-radius: 6px;
    z-index: 99;
    overflow: auto;
    border: 0.5px solid var(--outline);
    background: var(--primary-bg);

    &.center {
      left: 50%;
      transform: translate(-50%);
    }

    &.start {
      left: 0;
    }

    &.end {
      right: 0;
    }

    &.small {
      max-width: 160px;
    }

    .text-input {
      height: 30px;
      padding-left: 10px;
      color: var(--primary-text);
    }

    .dropdown-item {
      margin: 4px 0;
      cursor: pointer;
      padding: 2px 6px;
      cursor: pointer;
      transition: 100ms ease-in-out background-color, 100ms ease-in-out padding;
      border-radius: 6px;

      &.active, &.active:hover, &.focus, &:focus {
        background: var(--accent);
        color: #FFF;
      }
      &:hover {
        background: var(--hover);
      }
    }
  }
</style>